module.exports = "//public.zight.com/packs/media/images/download-cloud-90a1874dee4477797c567b8f1bd08b9b.svg";